<template>
  <div class="detail-layout">
    <RootMenu></RootMenu>
    <main class="main-content">
      <div class="back-button-container">
        <el-button 
          type="primary" 
          @click="goBack" 
          class="back-button"
          :icon="ArrowLeft"
        >
          返回
        </el-button>
      </div>
      <slot></slot>
    </main>
    <MyFooter></MyFooter>
    <OnlineService v-if="showOnlineService"></OnlineService>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ArrowLeft } from '@element-plus/icons-vue'
import RootMenu from './RootMenu.vue'
import MyFooter from './MyFooter.vue'
import OnlineService from './OnlineService.vue'

const props = defineProps({
  showOnlineService: {
    type: Boolean,
    default: true
  },
  fallbackPath: {
    type: String,
    default: '/'
  }
})

const router = useRouter()

const goBack = () => {
  if (window.history.length > 1) {
    router.back()
  } else {
    router.push(props.fallbackPath)
  }
}
</script>

<style scoped>
.detail-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  width: 100%;
}

.back-button-container {
  max-width: 1200px;
  margin: 20px auto 0;
  padding: 0 20px;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #0056b3, #0083c9);
  border: none;
  border-radius: 25px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 86, 179, 0.3);
}

.back-button:hover {
  background: linear-gradient(135deg, #004494, #0070b3);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 86, 179, 0.4);
}

@media (max-width: 768px) {
  .back-button-container {
    padding: 0 15px;
    margin: 15px auto 0;
  }
  
  .back-button {
    padding: 8px 20px;
    font-size: 13px;
  }
}
</style>
